import SvgIcon from "./main.vue";
export default SvgIcon;
